import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import Stroke from 'ol/style/Stroke';

export const labelTextStyle = new Text({
	font: 'bold 16px Ubuntu,sans-serif',
	overflow: true,
	stroke: new Stroke({
		width: 3,
		color: 'rgba(255, 255, 255, 0.9)',
	}),
	fill: new Fill({
		color: 'rgb(1, 38, 60)',
	}),
});

export const labelTextStyleDimmed = new Text({
	font: 'bold 14px Ubuntu,sans-serif',
	overflow: true,
	stroke: new Stroke({
		width: 2,
		color: 'rgb(255, 255, 255, 0.6)',
	}),
	fill: new Fill({
		color: 'rgb(1, 38, 60, 0.6)',
	}),
});

export const defaultBaseStyles = {
	default: new Style({
		fill: new Fill({
			color: 'rgb(210, 201, 189)',
		}),
		//stroke: new Stroke({
		//	width: 1,
		//	color: 'rgba(255, 255, 255, 0.8)',
		//}),
	}),
	special: new Style({
		fill: new Fill({
			color: 'rgb(73, 159, 228)',
		}),
	}),
	'very-special': new Style({
		fill: new Fill({
			color: 'rgb(255, 248, 229)',
		}),
	}),
};

export const defaultBaseStylesDimmed = {
	default: new Style({
		fill: new Fill({
			color: 'rgba(210,201,189, 0.5)',
		}),
	}),
	special: new Style({
		fill: new Fill({
			color: 'rgba(73, 159, 228, 0.5)',
		}),
	}),
	'very-special': new Style({
		fill: new Fill({
			color: 'rgba(255, 248, 229, 0.5)',
		}),
	}),
};

export default function (store) {
	let filter;
	let additionalFilter;
	let searchResultStaende;
	store.listen((data) => {
		filter = data.filter;
		additionalFilter = data.additionalFilter;
		searchResultStaende = data.searchResultStaende;
	});

	return function (feature, resolution) {
		const props = feature.getProperties();
		const type = props.type || 'default';

		const isFiltered =
			(filter && filter.indexOf(feature.getId()) < 0) ||
			(additionalFilter && additionalFilter.indexOf(feature.getId()) < 0);
		const isSearchResult =
			!searchResultStaende ||
			!searchResultStaende.length ||
			searchResultStaende.indexOf(feature.getId()) > -1;
		const isDimmed = isFiltered && !isSearchResult;

		/** @type {Style} baseStyle */
		const baseStyle = isDimmed
			? defaultBaseStylesDimmed[type]
			: defaultBaseStyles[type];
		if (!baseStyle) {
			console.info('style not found fot type', type);
			return [];
		}

		let style;
		if (props.fill && !isDimmed) {
			style = style || baseStyle.clone();
			style.getFill().setColor(props.fill);
		}

		if (props.number) {
			style = style || baseStyle.clone();

			if (resolution <= 0.5) {
				const labelStyle = (
					isDimmed ? labelTextStyleDimmed : labelTextStyle
				).clone();
				labelStyle.setText(props.number.trim());

				if (resolution >= 0.3) {
					labelStyle.setFont('normal 10px Ubuntu,sans-serif');
					//labelStyle.getStroke().setWidth(1);
				} else if (resolution >= 0.25) {
					labelStyle.setFont('bold 13px Ubuntu,sans-serif');
					//labelStyle.getStroke().setWidth(1);
				}

				//labelStyle.getStroke().setColor(style.getFill().getColor());
				style.setText(labelStyle);
			}
		}

		return style || baseStyle;
	};
}
